import { connect } from "react-redux";
import Feedback from "./Feedback";
import { getFeedbackRequest } from "../../../store/actions/sp.actions";
import { getLoading, getSPFeedback, getSpSetting } from "../../../store/selector/sp.selector";

const mapDispatchToProps = {
  getFeedbackList: getFeedbackRequest,
};

const mapStateToProps = (state) => {
  const feedbackObj = getSPFeedback(state);
  const loading = getLoading(state);
  const settings = getSpSetting(state);
  return { feedbackObj, loading, settings };
};

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
